import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles'

const CountMetricCard = ({ svgsrc, metricValue, metricDescription, loading, loaderHeight, classes = '', valueClasses = 'text-3xl', desClasses = '', allow_bug_dwnld = false, bugReport }) => {
  if (loading) {
    return (
      <div className={classes.replace('flex', '')}>
        <Skeleton width='100%' height={loaderHeight} />
      </div>
    )
  }

  return (
    <div className={'rounded-ds-md border border-gray-250 bg-white p-6 text-center shadow-ds-sm transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] hover:shadow-ds-md ' + classes}>
      <dt className='flex flex-row items-center justify-center'>
        <img className='inline-block h-5 w-5' src={svgsrc} alt='metric card avatar' />
        <span className={'font-jetbrains-mono font-semibold tabular-nums ml-3 leading-none text-gray-900 ' + valueClasses}>{metricValue || 0}</span>
      </dt>

      <p className={'mb-0 mt-1 text-xs leading-relaxed text-gray-600 ' + desClasses}>{metricDescription}</p>
      {allow_bug_dwnld &&
        <div className='flex flex-row items-center justify-center'>
          <button
            type='button'
            onClick={bugReport}
            className={joinButtonClasses(dsButtonPrimary, 'mt-3 h-9 px-4')}
          >
            Download bug report
          </button>
        </div>}
    </div>
  )
}

export default CountMetricCard
